import React from 'react';
import { styled as materialStyled } from '@mui/material/styles';
import { Select } from '@mui/material';

const CustomSelectComponent = materialStyled(Select)({
  height: '40px',
  borderRadius: '8px',
});

export default CustomSelectComponent;
